// extracted by mini-css-extract-plugin
export var brand = "_1p-9";
export var button = "_1p-0";
export var chevron = "_1p-v";
export var chevronButton = "_1p-w";
export var content = "_1p-n";
export var danger = "_1p-g";
export var dangerOutlined = "_1p-h";
export var dark = "_1p-l";
export var darkTheme = "_1p-c";
export var extraSmall = "_1p-4";
export var fullWidth = "_1p-8";
export var ghost = "_1p-d";
export var gray = "_1p-t";
export var icon = "_1p-p";
export var iconButton = "_1p-s";
export var iconButtonBorder = "_1p-x";
export var iconButtonBorderDark = "_1p-y";
export var iconButtonBorderLight = "_1p-z";
export var iconLeft = "_1p-q";
export var iconRight = "_1p-r";
export var large = "_1p-1";
export var light = "_1p-m";
export var medium = "_1p-2";
export var micro = "_1p-5";
export var nano = "_1p-7";
export var outlined = "_1p-k";
export var pending = "_1p-a";
export var primary = "_1p-i";
export var shadow = "_1p-o";
export var small = "_1p-3";
export var solidLight = "_1p-e";
export var solidLightBrand = "_1p-f";
export var spinner = "_1p-u";
export var transparent = "_1p-j";
export var warning = "_1p-b";
export var wideNano = "_1p-6";